import ClientForm, { ClientFormValues } from 'components/featured/Client/ClientForm/ClientForm';
import ClientFormPage from 'components/featured/Client/ClientFormPage';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import RoutePaths from 'routes/RoutePaths';
import { HuddleClientService } from 'service/huddle-client.service';

const ClientEdit = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [clientData, setClientData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [formValues, setFormValues] = useState<ClientFormValues | null>(null);
  const [isValid, setIsValid] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!id) return;
    const fetchClient = async () => {
      try {
        setLoading(true);
        const data = await HuddleClientService.getClientHuddleDetails(id);
        setClientData(data);
      } catch (err) {
        console.error('Failed to fetch client details:', err);
        navigate(RoutePaths.Client, { replace: true });
      } finally {
        setLoading(false);
      }
    };
    fetchClient();
  }, [id, navigate]);

  if (loading) return <>Loading client details…</>;
  if (!clientData) return null;

  const initialValues: Partial<ClientFormValues> = {
    clientType: clientData?.clientType ?? clientData?.category ?? '',
    salutation: clientData?.salutation ?? '',
    clientName: clientData?.Name ?? clientData?.name ?? '',
    linkEntity: Array.isArray(clientData?.linkEntity)
      ? clientData.linkEntity
      : clientData?.linkEntity
        ? [clientData.linkEntity]
        : [],
    agency: clientData?.agency ?? clientData?.agencyName ?? '',
    owner: clientData?.ownerId ?? clientData?.owner ?? clientData?.ownerName ?? '',
    league: clientData?.league ?? '',
    team: clientData?.team ?? '',
    position: clientData?.position ?? '',
    number: clientData?.number ?? '',
    status: clientData?.status ?? '',
    college: clientData?.college ?? '',
    loanOutCompany: clientData?.loanOutCompany ?? '',
    mobile: clientData?.mobile ?? clientData?.phone ?? '',
    phone: clientData?.workPhone ?? clientData?.Phone ?? '',
    email: clientData?.email ?? clientData?.Email ?? '',
    personalEmail: clientData?.personalEmail ?? '',
    profileImageUrl: clientData?.profileImageUrl ?? clientData?.avatar ?? '',
  };

  const handleChange = (values: ClientFormValues, valid: boolean) => {
    setFormValues(values);
    setIsValid(valid);
  };

  const handleSubmit = async () => {
    if (!formValues || !isValid || !id) return;
    setSubmitting(true);
    try {
      // TODO: call HuddleClientService.editHuddleClient(formValues, id)
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ClientFormPage
      isEdit={true}
      onSubmit={handleSubmit}
      submitting={submitting}
      primaryDisabled={!isValid}
    >
      <ClientForm initialValues={initialValues} onChange={handleChange} />
    </ClientFormPage>
  );
};

export default ClientEdit;
